<template>
  <!-- NOTIFICATIONS -->
  <div class="flex-1 flex-col flex">
    <div class="notification-top text-center p-5 bg-primary text-white">
      <h3 class="text-white">{{ unreadNotif2 }}</h3>
      <p class="opacity-75">New Fleet Reminders</p>
    </div>

    <ul class="bordered-items flex-1" style="overflow: scroll">
      <li
        v-for="ntf in unreadNotifications2"
        :key="ntf.idx"
        class="flex justify-between px-4 py-4 notification"
        @click="navigateToStockAlert(ntf.idx, ntf.readStatus)"
      >
        <div class="flex items-start">
          <feather-icon
            icon="MessageSquareIcon"
            :svgClasses="[`text-warning`, 'stroke-current mr-1 h-6 w-6']"
          ></feather-icon>
          <div class="mx-2">
            <span
              class="font-medium block notification-title"
              :class="[`text-${ntf.category}`]"
              >{{ ntf.title }}</span
            >
            <small>{{ ntf.msg }}</small>
          </div>
        </div>
        <small class="mt-1 whitespace-no-wrap">{{ ntf.create_time }}</small>
      </li>
    </ul>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      unreadNotif2: localStorage.getItem('unreadNotif2'),
      unreadNotifications2: JSON.parse(localStorage.getItem('unreadNotifications2')),
    };
  },
  mounted() {
    const self = this;
    if (self.unreadNotif2 > 0) {
      this.$http
        .patch(`personals/fms_notifications/${self.userInfo.uid}`)
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
          } else {
          }
        })
        .catch(function (error) {});
    }
  },
  methods: {},
};
</script>
